module.exports = __webpack_public_path__ + "static/media/0121_IMG_LE_SOL_66_PELER.f27bb799.webp";